import React from "react";
import { Form, Input } from "antd";
import { connect } from "react-redux";

const PriceFinal = ({ form, disabled, serviceAdditionals, parent }) => {
  const { getFieldDecorator, getFieldValue } = form;
  let price =
    getFieldValue("priceNoNds") && parseInt(getFieldValue("priceNoNds"));

  if (serviceAdditionals && price) {
    getFieldValue("additionalServices") &&
      getFieldValue("additionalServices").forEach(item => {
        const servicePrice = getFieldValue("serviceAdditionalPrice" + item);
        if (servicePrice) {
          price += parseInt(servicePrice);
        }
      });
  }

  return (
    <div className="offer-card__item double-margin">
      <span className="label">
        <span>Итоговая сумма {parent === "order" ? "заказа" : "предложения"}, руб:</span>
      </span>
      <Form.Item>
        {getFieldDecorator("priceFinal", {
          // initialValue: price
        })(<Input style={{ width: 224 }} disabled={disabled} />)}
      </Form.Item>
    </div>
  );
};

export default connect(
  state => ({
    serviceAdditionals: state.Common.Filters.serviceAdditionals
  }),
  {}
)(PriceFinal);
